<div class="content-body">
  <div class="header_aliados">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-12 col-lg-6 offset-lg-6">
          <div id="title_banner" class="d-flex flex-column">
            <h2>Bienvenido {{user.cliente}}</h2>
            <h5>al portal de Aliados Financieros</h5>
            <img src="assets/img/Logo_bancoldex_aliado.svg" alt="" class="img-logo-banner-internas">
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="dashboard container">
    <div class="row">
      <div class="info-container col-12 col-lg-3">
        <div class="bkg_color p-3">
          <p class="text-center text-lg-start">Solicitudes <br> pendientes por tramitar</p>
          <h3>{{conteoSolicitudes[3]}}</h3>
        </div>
      </div>
      <div class="info-container col-12 col-lg-3 mt-3 mt-lg-0">
        <div class="bkg_color p-3">
          <p class="text-center text-lg-start">Ofertas <br> enviadas</p>
          <h3>{{conteoSolicitudes[2]}}</h3>
        </div>
      </div>
      <div class="info-container col-12 col-lg-3 mt-3 mt-lg-0">
        <div class="bkg_color p-3">
          <p class="text-center text-lg-start">Ofertas rechazadas por los microempresarios</p>
          <h3>{{conteoSolicitudes[1]}}</h3>
        </div>
      </div>
      <div class="info-container col-12 col-lg-3 mt-3 mt-lg-0">
        <div class="bkg_color p-3">
          <p class="text-center text-lg-start">Ofertas aceptadas por los microempresarios</p>
          <h3>{{conteoSolicitudes[0]}}</h3>
        </div>
      </div>
    </div>
  </div>
  <div class="filter-container">
    <div class="text-center mt-2 mb-4" style="color: white;">
      <h3>Solicitudes pendientes por tramitar</h3>
    </div>
    <div class="container">
      <form [formGroup]="filterForm">
        <div class="row">
          <div class="col-12 col-sm-4 col-md-4 col-lg-2 col-xs-4">
            <div class="mb-3">
              <label for="idSolicitud" class="form-label">Nº de solicitud</label>
              <input type="text" class="form-control" formControlName="idSolicitud">
            </div>
          </div>
          <div class="col-12 col-sm-4 col-md-4 col-lg-2 col-xs-4">
            <div class="mb-3">
              <label for="fechaRecepcion" class="form-label">Fecha de recepción</label>
              <input type="date" class="form-control" formControlName="fechaRecepcion">
            </div>
          </div>
          <div class="col-12 col-sm-4 col-md-4 col-lg-2 col-xs-4">
            <div class="mb-3">
              <label for="idEstadoSolicitud" class="form-label">Estado de la solicitud</label>
              <select class="form-control" type="number" formControlName="idEstadoSolicitud">
                <option [value]="null">Seleccione...</option>
                @for (estado of estados; track estado) {
                  <option
                    [value]="estado.idEstadoSolicitudIntermediario">
                    {{ estado.nombre }}
                  </option>
                }
              </select>
            </div>
          </div>
          <div class="col-12 col-sm-4 col-md-4 col-lg-3 col-xs-4">
            <div class="mb-3">
              <label for="idDepartamento" class="form-label">Departamento</label>
              <select class="form-control" formControlName="idDepartamento"
                (change)="getCiudades($event.target.value)">
                <option [value]="null">Seleccione una opción</option>
                @for (departamento of departamentos; track departamento) {
                  <option
                    [value]="departamento.idDepartamento">
                    {{ departamento.nombreDepartamento }}
                  </option>
                }
              </select>
            </div>
          </div>
          <div class="col-12 col-sm-4 col-md-4 col-lg-3 col-xs-4">
            <div class="mb-3">
              <label for="idCiudad" class="form-label">Ciudad</label>
              <select class="form-control" formControlName="idCiudad">
                <option [value]="null">Seleccione una opción</option>
                @for (ciudad of ciudades; track ciudad) {
                  <option [value]="ciudad.idCiudad">
                    {{ ciudad.nombreCiudad }}
                  </option>
                }
              </select>
            </div>
          </div>
        </div>
        <div class="row justify-content-md-center mt-2 g-3">
          <div class="col-12 col-md-2 container-btn">
            <button type="submit" class="btn btn-primary hvr-shrink" style="width: 180px;"
            (click)="getSolicitudes()">Filtrar</button>
          </div>
          <div class="col-12 col-md-2 container-btn">
            <button type="submit" class="btn btn-primary hvr-shrink" style="width: 180px;"
            (click)="limpiarFiltro()">Limpiar</button>
          </div>
        </div>
      </form>
    </div>
  </div>
  @if (solicitudesPendientes.length>0) {
    <div class="table-container">
      <div class="container table-responsive">
        <table class="table table-bordered">
          <thead id="general">
            <tr>
              <th>Nº de solicitud</th>
              <th>Fecha de recepción solicitud</th>
              <th>Hora de recepción solicitud</th>
              <th>Días disponibles gestión</th>
              <th>Nombre del solicitante</th>
              <th>Tipo y número de documento</th>
              <th>Monto solicitado</th>
              <th>Estado de la solicitud</th>
              <th>Ubicación</th>
              <th id="acciones">Acciones</th>
            </tr>
          </thead>
          <tbody id="general_body">
            @for (solicitud of solicitudesPendientes; track solicitud; let i = $index) {
              <tr>
                <td id="id-sol"><a (click)="verDetalleSolicitud(i)"
                  [routerLink]="['../../solicitud/intermediario', solicitud.numeroSolicitud]">
                  <strong
                    placement="top"
                    tooltipClass="stylesToll"
                    container="body"
                    [openDelay]="500"
                    [ngbTooltip]="solicitud.idSolicitudBE ? mensajeEnviadaBE : ''">
                    {{solicitud.numeroSolicitud }}
                    @if (solicitud.idSolicitudBE != null) {
                      <span
                      class="badgeAccionesSol badge badge-primary badge-pill">1</span>
                    }</strong></a>
                  </td>
                  <td>{{solicitud.fechaRecepcion | date:'dd/MM/yyyy':'America/Bogota'}}</td>
                  <td>{{solicitud.fechaRecepcion | date:'hh:mm a':'America/Bogota'}}</td>
                  <td>{{solicitud.diasDisponiblesGestion}} días</td>
                  <td>{{solicitud.nombreDeSolicitante}}</td>
                  <td>{{solicitud.tipoYNumeroDeDocumento}}</td>
                  <td>{{solicitud.montoSolicitado | currency:'USD' : 'symbol' : '1.0-0'}}</td>
                  <td>{{solicitud.estadoSolicitud}}</td>
                  <td>
                    {{ !solicitud.ciudad.data[0] ? '' : solicitud.ciudad.data[0].nombreCiudad }} -
                    {{ !solicitud.departamento.data[0] ? '' :
                    solicitud.departamento.data[0].nombreDepartamento }}
                  </td>
                  <td>
                    @if (solicitud.idEstadoSolicitud_NeoEstadoSolicitud == 4 || solicitud.idEstadoSolicitud_NeoEstadoSolicitud == 3) {
                      <div class="mt-2">
                        <span class="d-inline-block">
                          <button type="button" class="btn border-0 btn-style pe-4" (click)="verDetalleSolicitud(i)"
                            placement="top"
                            tooltipClass="stylesToll"
                            container="body"
                            [openDelay]="500"
                            [ngbTooltip]="solicitud.observacionBancoldex
                            ? mensajeNotificacion
                            : 'Ver detalle solicitud'">
                            <div class="d-flex flex-row align-items-center">
                              <i class="fas fa-eye text-primary"></i>
                              @if (solicitud.observacionBancoldex != null) {
                                <span class="badgeAcciones badge badge-primary badge-pill">1</span>
                              }
                            </div>
                          </button>
                        </span>
                        <button
                        type="button"
                        class="btn border-0 btn-icon-style"
                        (click)="devolver(i)"
                        placement="top"
                        tooltipClass="stylesToll"
                        container="body"
                        [openDelay]="500"
                        [ngbTooltip]="'Devolver oferta a revisor'" >
                          <i class="fas fa-undo-alt text-danger"></i>
                        </button>
                        @if (solicitud.idEstadoSolicitud_NeoEstadoSolicitud==4) {
                          <button type="button"
                                  class="btn border-0 btn-icon-style" aria-label="Close"
                                  (click)="negarSolicitud(i)"
                                  placement="top"
                                  tooltipClass="stylesToll"
                                  container="body"
                                  [openDelay]="500"
                                  [ngbTooltip]="'Negar oferta'">
                            <i class="fas fa-times-circle text-danger"></i>
                          </button>
                        }
                        @if (solicitud.idEstadoSolicitud_NeoEstadoSolicitud==4) {
                          <button type="button"
                                  class="btn border-0 btn-icon-style"
                                  (click)="aprobar(i)"
                                  placement="top"
                                  tooltipClass="stylesToll"
                                  container="body"
                                  [openDelay]="500"
                                  [ngbTooltip]="'Aprobar oferta'">
                            <i class="fas fa-check-circle text-success"></i>
                          </button>
                        }
                        @if (solicitud.idEstadoSolicitud_NeoEstadoSolicitud==3) {
                          <button type="button"
                                  class="btn border-0 btn-icon-style"
                                  (click)="aprobar(i)"
                                  placement="top"
                                  tooltipClass="stylesToll"
                                  container="body"
                                  [openDelay]="500"
                                  [ngbTooltip]="'Confirmar negación'">
                            <i class="fas fa-times-circle text-danger"></i>
                          </button>
                        }
                      </div>
                    }
                    @if (solicitud.idEstadoSolicitud_NeoEstadoSolicitud == 2 || solicitud.idEstadoSolicitud_NeoEstadoSolicitud == 1) {
                      <div class="mt-2">
                        @if (i==habilitarCampos) {
                          <button type="button"
                                  class="btn border-0 btn-icon-style"
                                  aria-label="Close"
                                  (click)="negarSolicitud(i)"
                                  placement="top"
                                  tooltipClass="stylesToll"
                                  container="body"
                                  [openDelay]="500"
                                  [ngbTooltip]="'Negar solicitud'">
                            <i class="fas fa-times-circle text-danger"></i>
                          </button>
                        }
                        @if (i==habilitarCampos) {
                          <button type="button"
                                  class="btn border-0 btn-icon-style"
                                  (click)="aprobar(i)"
                                  placement="top"
                                  container="body"
                                  [openDelay]="500"
                                  tooltipClass="stylesToll"
                                  [ngbTooltip]="'Crear oferta'">
                            <i class="fas fa-check-circle text-success"></i>
                          </button>
                        }
                        <span class="d-inline-block">
                          <button type="button"
                          class="btn border-0 btn-style"
                          (click)="verDetalleSolicitud(i)"
                          placement="top"
                          tooltipClass="stylesToll"
                          container="body"
                          [openDelay]="500"
                          [ngbTooltip]="solicitud.observacionBancoldex
                          ? mensajeNotificacion
                          : 'Ver detalle solicitud'">
                            <div class="d-flex flex-row align-items-center">
                              <i class="fas fa-eye text-primary"></i>
                              @if (solicitud.observacionBancoldex != null) {
                                <span class="badgeAcciones badge badge-primary badge-pill">1</span>
                              }
                            </div>
                          </button>
                        </span>
                      </div>
                    }
                    @if (solicitud.idEstadoSolicitud_NeoEstadoSolicitud == 8) {
                      <div class="mt-2" class="mt-2">
                        <span class="d-inline-block">
                          <button
                          type="button"
                          class="btn pe-4 border-0 btn-style"
                          (click)="verDetalleSolicitud(i)"
                          placement="top"
                          tooltipClass="stylesToll"
                          container="body"
                          [openDelay]="500"
                          [ngbTooltip]="solicitud.formalizacion.tooltip
                          ? solicitud.formalizacion.mensaje
                          : 'Ver detalle solicitud'">
                            <div class="d-flex flex-row align-items-center">
                              <i class="fas fa-eye text-primary"></i>
                              @if (solicitud.formalizacion.tooltip) {
                                <span class="badgeAcciones badge badge-primary badge-pill">1</span>
                              }
                            </div>
                          </button>
                        </span>
                        @if (solicitud.idSolicitudBE == null) {
                          <button type="button"
                                  class="btn border-0 btn-icon-style"
                                  aria-label="Close"
                                  (click)="negarDesembolso(i)"
                                  placement="top"
                                  tooltipClass="stylesToll"
                                  container="body"
                                  [openDelay]="500"
                                  [ngbTooltip]="'Negar desembolso'">
                            <i class="fas fa-times-circle text-danger"></i>
                          </button>
                        }
                        @if (solicitud.tipoRecursoUtilizado == 'RECURSOS_PROPIOS') {
                          <button type="button"
                                  class="btn  border-0 btn-icon-style"
                                  aria-label="Close"
                                  (click)="aprobarDesembolso(i)"
                                  placement="top"
                                  tooltipClass="stylesToll"
                                  container="body"
                                  [openDelay]="500"
                                  [ngbTooltip]="'Confirmar desembolso'">
                            <i class="fas fa-check-circle text-success"></i>
                          </button>
                        }
                        @if (solicitud.tipoRecursoUtilizado == 'RECURSOS_BANCOLDEX' && solicitud.idSolicitudBE == null) {
                          <button type="button"
                                  class="btn border-0 btn-icon-style"
                                  aria-label="Close"
                                  (click)="aprobarDesembolsoBx(i)"
                                  placement="top"
                                  tooltipClass="stylesToll"
                                  container="body"
                                  [openDelay]="500"
                                  [ngbTooltip]="'¡Al dar clic sobre este botón, podrás enviar esta solicitud
                                  automáticamente al portal de Banca Electrónica de Bancóldex para continuar con tu solicitud!'">
                            <i class="fas fa-share-square text-success"></i>
                          </button>
                        }
                      </div>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
          <app-pagination (event)="changePage($event)" [paginaActual]="paginaActual"
          [totalPaginas]="totalPaginas"></app-pagination>
        </div>
      </div>
    }
    @if (solicitudesPendientes.length<1) {
      <div class="row justify-content-md-center text-center mt-5"
        >
        <div class="col-12 col-sm-12">
          <h3>No tiene solicitudes pendientes</h3>
        </div>
      </div>
    }
  </div>


  <!-- Modal -->
  <div class="modal fade" id="negarModal" tabindex="-1" aria-labelledby="editModalLabel"
    aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered" style="max-width: 600px;">
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title" id="editModalLabel">¿SEGURO QUE DESEAS NEGAR LA SOLICITUD DE ESTE
          CLIENTE?</h2>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="cancelar()">

          </button>
        </div>
        <div class="container modal-body-monto justify-content-md-center">
          <div class="row">
            <div class="col-12 col-sm-12">
              <p>Número de solicitud: {{solicitudNegar.idSolicitud}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-12">
              <div class="mb-3">
                <p>Motivo de la negación</p>
                <select class="selectpicker" type="number" data-width="90%" name="tipoNegacion"
                  #selectOpcionNegacion="ngModel"
                  [(ngModel)]="solicitudNegar.id_tipo_negacion"
                  [(ngModel)]="idOpcionNegacion"
                  required title="Seleccione una opción">
                  <option>Seleccione una opción</option>
                  @for (tipoNegacion of tiposNegacion; track tipoNegacion) {
                    <option [(value)]="tipoNegacion.idTipoNegacion">
                    {{tipoNegacion.nombre}}</option>
                  }
                </select>
                <div class="message-error" [class.invalid]="selectOpcionNegacion.invalid">
                  Campo es obligatorio*
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-12">
              <div class="mb-3">
                <label for="textNegacionObservacion">Observación</label>
                <textarea class="form-control" name="observacionNegacion" [(ngModel)]="textNegacionObservacion" required
                #textObservacionNegacion="ngModel" rows="4" minlength="1" maxlength="800"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="cancelar()">Cancelar</button>
          <button type="button" class="btn btn-primary"
            [disabled]="(selectOpcionNegacion.invalid && textNegacionObservacion.length==0)"
          (click)="confirmarNegacionSolicitud()">Negar</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div class="modal fade" id="aceptarModal" tabindex="-1" aria-labelledby="aceptarModalLabel"
    aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title text-white" id="aceptarModalLabel">CONFIRMAR DESEMBOLSO</h3>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="cancelar()">
          </button>
        </div>
        <div class="modal-body-monto justify-content-md-center">
          <form [formGroup]="confirmarForm">
            <div class="row mt-2">
              <div class="col-11 col-lg-5 col-sm-11 me-3 ms-3">
                <b>Número de solicitud:</b>
              </div>
              <div class="col-11 col-lg-5 col-sm-11 me-3 ms-3">
                <b>{{idSolicitudAprobar}}</b>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-11 col-sm-11 me-3 ms-3">
                <p>Valor desembolsado final:</p>
                <div class="input-group">
                  <span class="input-group-text">$</span>
                  <input class="form-control"  placeholder="COP" type="text" maxlength="11" appOnlyNumbers
                    formControlName="desembolso" [ngClass]="{ 'is-invalid': validateField('desembolso')} " required>
                    <div class="invalid-feedback" style="color: #dc3545 !important;">
                      Campo obligatorio
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-11 col-lg-5 col-sm-11 me-3 ms-3">
                  <p>Valor tasa final E.A.:</p>
                  <input type="text" class="form-control" maxlength="7" (keyup)="validarTasa()"
                    (keypress)="validateNumber($event)" [ngClass]="{'is-invalid':validateField('valorTasa')}"
                    formControlName="valorTasa" required />
                    <div class="invalid-feedback" style="color: #dc3545 !important;">
                      Campo obligatorio, numérico de 3 caracteres entero y 3 decimales
                    </div>
                  </div>
                  <div class="col-11 col-lg-5 col-sm-11 me-3 ms-3">
                    <p>Plazo final (meses): </p>
                    <input class="form-control" type="number" min="1" max="{{CANTIDAD_MAXIMA_PLAZO_MESES}}" maxlength="3"
                      appOnlyNumbers formControlName="plazo" [ngClass]="{ 'is-invalid': validateField('plazo')} " required>
                      <div class="invalid-feedback" style="color: #dc3545 !important;">
                        Campo obligatorio. Rango permitido 1 a {{CANTIDAD_MAXIMA_PLAZO_MESES}} meses.
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="mb-3 col-5 col-sm-5 me-3 ms-3">
                      <p>Tipo de recursos desembolsados:</p>
                      <select class="form-control" data-width="100%" [ngClass]="{ 'is-invalid': validateField('tipoRecurso')} "
                        formControlName="tipoRecurso" title="Seleccione una opción">
                        <option value="Propios">Propios</option>
                        <option value="Bancóldex">Bancóldex</option>
                      </select>
                      <div class="invalid-feedback" style="color: #dc3545 !important;">
                        Campo obligatorio
                      </div>
                    </div>
                    <div class="mb-3 col-5 col-sm-5 me-3 ms-3">
                      <p>¿El crédito a desembolsar cuenta con garantía?</p>
                      <div class="col-sm">
                        <div class="form-check form-check-inline ms-4" [ngClass]="{'is-invalid':validateField('garantia')}">
                          <input class="form-check-input" type="radio" formControlName="garantia" [value]="1"
                            [ngClass]="{'is-invalid':validateField('garantia')}" />
                            <label class="form-check-label" for="garantia" style="color: black !important;"> Sí </label>
                          </div>
                          <div class="form-check form-check-inline ms-4" [ngClass]="{'is-invalid':validateField('garantia')}">
                            <input class="form-check-input" type="radio" formControlName="garantia" [value]="0"
                              [ngClass]="{'is-invalid':validateField('garantia')}" />
                              <label class="form-check-label" for="garantia" style="color: black !important;"> No </label>
                            </div>
                            <div class="invalid-feedback" style="color: #dc3545 !important;">
                              Campo obligatorio
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-3">
                        <div class="mb-3 col-12 col-sm-12 me-3 ms-3">
                          <p>Observación:</p>
                          <textarea class="form-control" type="text" style="width: 90%;" rows="3" name="observacion" maxlength="200"
                            formControlName="observacion" [ngClass]="{ 'is-invalid': validateField('observacion')} "
                          required></textarea>
                          <div class="invalid-feedback" style="color: #dc3545 !important;">
                            Campo obligatorio
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-primary"
                      (click)="confirmarAprobacionDesembolso()">Confirmar
                    Desembolso</button>
                    <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="cancelar()">Cancelar</button>
                  </div>
                </div>
              </div>
            </div>
            <!-- Modal Confirmar desembolso Recursos Bancóldex -->
            <div class="modal fade" id="confirmarDesembolsoBX" tabindex="-1" aria-labelledby="confirmarDesembolsoBXLabel"
              aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header">
                    <h3 class="modal-title text-white text-center" id="confirmarDesembolsoBXLabel">CONFIRMAR ENVÍO A BANCA ELECTRÓNICA</h3>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="cancelar()">

                    </button>
                  </div>
                  <div class="modal-body-monto justify-content-md-center">
                    <form [formGroup]="confirmarBxForm">
                      <div class="row mt-2">
                        <div class="col-11 col-lg-5 col-sm-11 me-3 ms-3">
                          <b>Número de solicitud:</b>
                        </div>
                        <div class="col-11 col-lg-5 col-sm-11 me-3 ms-3">
                          <b>{{idSolicitudAprobar}}</b>
                        </div>
                      </div>
                      <div class="row mt-3">
                        <div class="col-5 col-sm-5 me-3 ms-3">
                          <p>¿El cliente de esta solicitud requiere garantía?</p>
                          <div class="col-sm">
                            <div class="form-check form-check-inline ms-4" [ngClass]="{'is-invalid':validateFieldBx('aplicaFNG')}">
                              <input class="form-check-input" type="radio" formControlName="aplicaFNG" [value]="true"
                                [ngClass]="{'is-invalid':validateFieldBx('aplicaFNG')}" (click)="validarGarantia(true)"
                                (keydown.enter)="validarGarantia(true)" />
                                <label class="form-check-label" for="aplicaFNG"  style="color: black !important;"> Sí </label>
                              </div>
                              <div class="form-check form-check-inline ms-4" [ngClass]="{'is-invalid':validateFieldBx('aplicaFNG')}">
                                <input class="form-check-input" type="radio" formControlName="aplicaFNG" [value]="false"
                                  [ngClass]="{'is-invalid':validateFieldBx('aplicaFNG')}" (click)="validarGarantia(false)"
                                  (keydown.enter)="validarGarantia(false)" />
                                  <label class="form-check-label" for="aplicaFNG"  style="color: black !important;"> No </label>
                                </div>
                                <div class="invalid-feedback" style="color: #dc3545 !important;">
                                  Campo obligatorio
                                </div>
                              </div>
                            </div>
                            @if (confirmarBxForm.get('aplicaFNG').value == true) {
                              <div class="col-5 col-lg-5 col-sm-5 me-3 ms-3">
                                <p>Porcentaje de cobertura (%):</p>
                                <input type="number" class="form-control" min="1" max="100" [maxlength]="3"
                                  [ngClass]="{'is-invalid':validateFieldBx('margenFNG')}" formControlName="margenFNG" />
                                  <div class="invalid-feedback" style="color: #dc3545 !important;">
                                    Campo obligatorio, numérico de 1 a 100.
                                  </div>
                                </div>
                              }
                            </div>
                            @if (confirmarBxForm.get('aplicaFNG').value == true) {
                              <div class="row mt-3">
                                <div class="mb-3 col-12 col-sm-12 me-3 ms-3">
                                  <p>Digita aquí la descripción de la garantía:</p>
                                  <textarea class="form-control" type="text" style="width: 90%;" rows="3" name="descripcionGarantia"
                                    minlength="20" maxlength="300" formControlName="descripcionGarantia"
                                  [ngClass]="{'is-invalid': validateFieldBx('descripcionGarantia')} "></textarea>
                                  <div class="invalid-feedback" style="color: #dc3545 !important;">
                                    Campo obligatorio. Ingrese entre 20 y 300 caracteres. <br>Solo letras, números y espacios.
                                  </div>
                                </div>
                              </div>
                            }
                            <div class="row mt-2">
                              <div class="col-8 col-sm-8 me-3 ms-3">
                                <p>Digita aquí el número del pagaré asignado:</p>
                                <input class="form-control" type="text" maxlength="25" formControlName="numeroReferenciaPagareIF"
                                  [ngClass]="{ 'is-invalid': validateFieldBx('numeroReferenciaPagareIF')}"
                                  (keydown.space)="$event.preventDefault()" required>
                                  <div class="invalid-feedback" style="color: #dc3545 !important;">
                                    Campo obligatorio, longitud máxima de 25 caracteres.
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                          <div class="modal-footer mt-3">
                            <button type="button" class="btn btn-primary" [disabled]="confirmarBxForm.invalid"
                            (click)="confirmarDesembolsoRecursosBancoldex()">Enviar SCR</button>
                            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="cancelar()">Cancelar</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Modal -->
                    <div class="modal fade" id="negarDesembolsoModal" tabindex="-1"
                      aria-labelledby="negarModalDesembolsoLabel" aria-hidden="true"
                      data-bs-backdrop="static" data-bs-keyboard="false">
                      <div class="modal-dialog modal-dialog-centered" style="max-width: 600px;">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h2 class="modal-title text-white" id="negarModalDesembolsoLabel">NEGAR DESEMBOLSO</h2>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="cancelar()">

                            </button>
                          </div>
                          <div class="container modal-body-monto justify-content-md-center">
                            <div class="row">
                              <div class="col-12 col-sm-12">
                                <p>Número de solicitud: {{idSolicitudNegar}}</p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 col-sm-12">
                                <div class="mb-3">
                                  <p>Motivo de la negación:</p>
                                  <select class="selectpicker" title="Seleccione una opción" type="number"
                                    data-width="100%" name="tipoNegacion"
                                    [(ngModel)]="idTipoNegacion"
                                    required
                                    #selectMotivoNegacion="ngModel">
                                    @for (tipoNegacion of tiposNegacionDesembolso; track tipoNegacion) {
                                      <option [(value)]="tipoNegacion.idTipoNegacionDesembolso"
                                        >
                                      {{tipoNegacion.nombre}}</option>
                                    }
                                  </select>
                                  <div class="message-error" [class.invalid]="selectMotivoNegacion.invalid">
                                    Campo es obligatorio*
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 col-sm-12">
                                <div class="mb-3">
                                  <label for="textDesembolsoObservacion">Observación*</label>
                                  <textarea class="form-control" name="observacionNegacion"
                                    [(ngModel)]="textDesembolsoObservacion"
                                    required
                                    #textAreaObservacion="ngModel"
                                  rows="4" minlength="1" maxlength="3000"></textarea>
                                  <div class="message-error" [class.invalid]="textAreaObservacion.invalid">
                                    Campo obligatorio*
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-primary"
                              [disabled]="(selectMotivoNegacion.invalid && textAreaObservacion.invalid)"
                              (click)="confirmarNegacionDesembolso()">Confirmar
                            Negacion</button>
                            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="cancelar()">Cancelar</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Modal -->
                    <div class="modal fade text-center" id="confirmarDesembolso" tabindex="-1" aria-labelledby="aceptarModalLabel" aria-hidden="true"
                      data-bs-backdrop="static" data-bs-keyboard="false">
                      <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h4 class="modal-title text-white" id="confirmarDesembolso">CONFIRMAR DESEMBOLSO</h4>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="cancelar()">

                            </button>
                          </div>
                          <div class="modal-body justify-content-md-center">
                            <div class="row">
                              <div class="col-12 col-sm-12">
                                <h5 style="color: black;">¿Estas seguro que deseas confirmar el desembolso a la solicitud {{idSolicitudAprobar}},
                                  por un valor de ${{this.confirmarForm.get('desembolso').value}} con una tasa de {{this.confirmarForm.get('valorTasa').value}}%
                                y con plazo de {{this.confirmarForm.get('plazo').value}} meses?.</h5>
                              </div>
                            </div>
                          </div>
                          <div class="modal-footer justify-content-md-center">
                            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="confirmarDesembolso()">Confirmar</button>
                            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="cancelar()">Cancelar</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <app-footer></app-footer>
                    <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
